import { lazyNamed, loadable, Loading } from '@work4all/components';

export const CalendarLazy = lazyNamed(() => import('./Calendar'), 'Calendar');

export const Calendar = loadable(CalendarLazy, <Loading />);
